import React, { useState ,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Table, Typography, TableBody, TableCell, MenuItem,view,CircularProgress,LinearProgress,Box, Select, TableContainer, TableHead, TableRow, Paper, Grid,Button, 
  InputLabel, FormControl, Card, CardContent, CardHeader, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogTitle
} from "@mui/material";
import {ToastContainer } from "react-toastify";  // For toast messages, ensure you have react-toastify installed
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import LoyaltyRoundedIcon from '@mui/icons-material/LoyaltyRounded';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import VerifiedIcon from '@mui/icons-material/Verified';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { GlobalStyles } from "@mui/system";
import { useAuth } from '../../../AuthProvider';

import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer, Legend } from 'recharts';
import { BarChart, XAxis, YAxis, Bar } from 'recharts';

import CryptoJS from 'crypto-js';

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const StoreDashboard = () => {
  const [view, setView] = useState('dashboard');
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();
  const { oId ,userId,role,pId} = useAuth(); // Assuming you have a way to get the organization ID from context or props
  const [notices, setNotices] = useState([]);
  

  // newely code
 
  // States
  const [quotations, setQuotations] = useState([]);
  const [filteredQuotations, setFilteredQuotations] = useState([]);
  const [unPaidCount, setUnPaidCount] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [totalPaidAmount,setTotalPaidAmount]=useState(0)
  const [itemsloading, setItemsLoading] = useState(false);
  const [savedItems, setSavedItems] = useState([]);
  const [itemAmounts, setItemAmounts] = useState([]);
  const [selectedValue, setSelectedValue] = useState("currentMonth"); // Default value for the dropdown
  const [totalPurchaseAmount, setTotalPurchaseAmount] = useState(0); // Default value can be 0 or any appropriate initial value
  const [totalExpensesAmount, setTotalExpensesAmount] = useState(0);


  const [loadingNotices, setLoadingNotices] = useState(true);
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;


  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const [selectedMonth, setSelectedMonth] = useState(months[new Date().getMonth()]);
  const [expenseData, setExpenseData] = useState([]);

  const getLastThreeMonths = (selectedMonth) => {
  const monthOrder = [
    'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
    'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'
  ];
  
  const index = monthOrder.indexOf(selectedMonth.toUpperCase());
  const result = [];

  for (let i = 2; i >= 0; i--) {
    const monthIndex = (index - i + 12) % 12;
    result.push(monthOrder[monthIndex]);
  }

  return result; // Will return in order: [NOVEMBER, DECEMBER, JANUARY] when selectedMonth is JANUARY
};

  
  const cardStyle = {
    padding: "10px",
    position: "relative",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    height: "40px",
  };

  


    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/STORE_DEPARTMENT/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
useEffect(() => {
  if (isPrincipal) {
    fetchUsers();
  }
}, []); // ✅ Only runs on mount


 
  const handleDateRangeChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedValue(selectedValue);
  };
 
//Sales Card cunts code
const fetchSoldItemCountsData = async () => {
  if (!oId || !UserId) {
    console.warn("Missing required parameters to fetch data.");
    return;
  }

  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

  switch (selectedValue) {
    case "today":
      endpoint = `${baseUrl}/api/storeDashboard/store/totalAmount/today/${formattedDate}/${oId}/${UserId}`;
      break;
    case "yesterday":
     
    endpoint = `${baseUrl}/api/storeDashboard/store/totalAmount/yesterday/${formattedDate}/${oId}/${UserId}`;
      break;
    case "lastWeek":
     
    endpoint = `${baseUrl}/api/storeDashboard/store/totalAmount/lastWeek/${formattedDate}/${oId}/${UserId}`;
      break;
    case "currentMonth":
     
    endpoint = `${baseUrl}/api/storeDashboard/store/totalAmount/currentMonth/${formattedDate}/${oId}/${UserId}`;
      break;
 
    case "lastSixMonths":
     
    endpoint = `${baseUrl}/api/storeDashboard/store/totalAmount/lastSixMonths/${formattedDate}/${oId}/${UserId}`;
      break;
    case "currentAcademicYear":
     
    endpoint = `${baseUrl}/api/storeDashboard/store/totalAmount/academicYear/${formattedDate}/${oId}/${UserId}`; // Assuming financial year starts from April
      break;
   
    default:
      endpoint = `${baseUrl}/api/storeDashboard/store/totalAmount/currentMonth/${formattedDate}/${oId}/${UserId}`;
      break;
  }

  const response = await fetch(endpoint);
        if (!response.ok) {
          // throw new Error('Failed to fetch users');
          console.log(`Failed to fetch data: ${response.status}`)
      }
        // if (!response.ok) throw new Error(`Failed to fetch data: ${response.status}`);
   
        const data = await response.json();
        setItemAmounts(data);

   
      } catch (error) {
        console.error("Error fetching expenses data:", error);
        setItemAmounts([]);
      }
};
   // Automatically fetch when dependencies change
   useEffect(() => {
    fetchSoldItemTablesData();
    fetchSoldItemCountsData();
  }, [selectedValue,oId,UserId]);
     


  //Sales Items Table List code
    const fetchSoldItemTablesData = async () => {
    if (!oId || !UserId) {
      console.warn("Missing required parameters to fetch data.");
      setItemsLoading(false);
      return;
    }
    setItemsLoading(true);  
 
    try {
      let endpoint = "";
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
 
    switch (selectedValue) {
      case "today":
        endpoint = `${baseUrl}/api/soldItems/store/getTodaySoldItems/today/${formattedDate}/${oId}/${UserId}`;
        break;
      case "yesterday":
       
      endpoint = `${baseUrl}/api/soldItems/store/getYesterdaySoldItems/yesterday/${formattedDate}/${oId}/${UserId}`;
        break;
      case "lastWeek":
       
      endpoint = `${baseUrl}/api/soldItems/store/getLastWeekSoldItems/lastweek/${formattedDate}/${oId}/${UserId}`;
        break;
      case "currentMonth":
       
      endpoint = `${baseUrl}/api/soldItems/store/getCurrentMonthSoldItems/currentmonth/${formattedDate}/${oId}/${UserId}`;
        break;
   
      case "lastSixMonths":
       
      endpoint = `${baseUrl}/api/soldItems/store/getLastSixMonthsSoldItems/lastsixmonths/${formattedDate}/${oId}/${UserId}`;
        break;

      case "currentAcademicYear":
       
      endpoint = `${baseUrl}/api/soldItems/store/getAcademicYearSoldItems/academicyear/${formattedDate}/${oId}/${UserId}`; // Assuming financial year starts from April
        break;
     
      
    }

    const response = await fetch(endpoint);
          if (!response.ok) {
            // throw new Error('Failed to fetch users');
            console.log(`Failed to fetch data: ${response.status}`)
        }
          // if (!response.ok) throw new Error(`Failed to fetch data: ${response.status}`);
     
          const data = await response.json();
          setSavedItems(Array.isArray(data) ? data : []);

     
        } catch (error) {
          console.error("Error fetching expenses data:", error);
          setSavedItems([]);
        } finally {
          setItemsLoading(false);
        }
  };


  //card Purchase Count
  const fetchTotalPurchaseAmount = async () => {
    if(!UserId) return;
    try {
      let endpoint = "";
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
 
      switch (selectedValue) {
        case "today":
          endpoint = `${baseUrl}/api/purchase/store/getTodayPurchaseAmount/${formattedDate}/${oId}/${UserId}`;
          break;
        case "yesterday":
          endpoint = `${baseUrl}/api/purchase/store/getYesterdayPurchaseAmount/${formattedDate}/${oId}/${UserId}`;
          break;
        case "lastWeek":
          endpoint = `${baseUrl}/api/purchase/store/getLastWeekPurchaseAmount/${formattedDate}/${oId}/${UserId}`;
          break;
        case "currentMonth":
          endpoint = `${baseUrl}/api/purchase/store/getThisMonthPurchaseAmount/${formattedDate}/${oId}/${UserId}`;
          break;
        case "lastSixMonths":
          endpoint = `${baseUrl}/api/purchase/store/getLastSixMonthsPurchaseAmount/${formattedDate}/${oId}/${UserId}`;
          break;
        case "currentAcademicYear":
          endpoint = `${baseUrl}/api/purchase/store/getCurrentAcademicYearPurchaseAmount/${formattedDate}/${oId}/${UserId}`;
          break;
      }
 
      const response = await fetch(endpoint);
      if (!response.ok) throw new Error("Failed to fetch data");
 
      const data = await response.json();
      setTotalPurchaseAmount(data.amount); // ✅ Update to match API response
 
    } catch (error) {
      console.error("Error fetching purchase amounts:", error);
    }
  };
 
  useEffect(() => {
    fetchTotalPurchaseAmount();
  }, [selectedValue,UserId]);


// card Expenses count 
// const fetchTotalExpensesAmount = async () => {
//   try {
//     let endpoint = "";
//     const today = new Date();
//     const UserId = userId || selectedUsers;
//     const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

//     switch (selectedValue) {
//       case "today":
//         endpoint = `${baseUrl}/api/AllExpenses/todayExpensesAmount/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
//         break;
//       case "yesterday":
//         endpoint = `${baseUrl}/api/AllExpenses/yesterdayExpensesAmount/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
//         break;
//       case "lastWeek":
//         endpoint = `${baseUrl}/api/AllExpenses/lastWeekExpensesAmount/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
//         break;
//       case "currentMonth":
//         endpoint = `${baseUrl}/api/AllExpenses/thisMonthExpensesAmount/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
//         break;
//       case "lastSixMonths":
//         endpoint = `${baseUrl}/api/AllExpenses/getLastSixMonthsExpensesAmount/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
//         break;
//       case "currentAcademicYear":
//         endpoint = `${baseUrl}/api/AllExpenses/getCurrentAcademicYear/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
//         break;
//       default:
//         console.warn("Invalid selectedValue for expenses!");
//         return;
//     }

//     const response = await fetch(endpoint);
//     if (!response.ok) throw new Error("Failed to fetch expenses data");

//     const data = await response.json();
//     setTotalExpensesAmount(data.amount ); // if data.amount is undefined, default to 0

//   } catch (error) {
//     console.error("Error fetching expenses amounts:", error);
//   }
// };

// useEffect(() => {
//   fetchTotalExpensesAmount();
// }, [selectedValue]);

const fetchTotalExpensesAmount = async () => {
  try {
    const UserId = userId || selectedUsers;
    if (!UserId || !selectedValue) {
      console.warn("UserId or selectedValue missing — skipping API call.");
      return;
    }

    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    let endpoint = "";

    switch (selectedValue) {
      case "today":
        endpoint = `${baseUrl}/api/AllExpenses/todayExpensesAmount/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/AllExpenses/yesterdayExpensesAmount/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/AllExpenses/lastWeekExpensesAmount/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
        break;
      case "currentMonth":
        endpoint = `${baseUrl}/api/AllExpenses/thisMonthExpensesAmount/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
        break;
      case "lastSixMonths":
        endpoint = `${baseUrl}/api/AllExpenses/getLastSixMonthsExpensesAmount/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
        break;
      case "currentAcademicYear":
        endpoint = `${baseUrl}/api/AllExpenses/getCurrentAcademicYear/STORE_DEPARTMENT/${UserId}/${oId}?date=${formattedDate}`;
        break;
      default:
        console.warn("Invalid selectedValue for expenses!");
        return;
    }

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch expenses data");

    const data = await response.json();
    setTotalExpensesAmount(data.amount || 0); // fallback to 0 if undefined
  } catch (error) {
    console.error("Error fetching expenses amounts:", error);
  }
};

useEffect(() => {
  const UserId = userId || selectedUsers;
  if (UserId && selectedValue) {
    fetchTotalExpensesAmount();
  }
}, [userId, selectedUsers, selectedValue]);



const pieData = [
  { name: 'Sales', value: itemAmounts || 0, color: '#007bff' },
  { name: 'Purchase', value: totalPurchaseAmount || 0, color: '#28a745' },
  { name: 'Expenses', value: totalExpensesAmount || 0, color: '#dc3545' },
];
  const Payments = () => (
<Card
  sx={{
    height: '90%',
    boxShadow: 5,
    marginTop:'20px',
    borderRadius: '16px',
    padding: 2,
    background: 'linear-gradient(135deg, #f5f7fa, #e1e5ee)',
    transition: 'all 0.3s ease-in-out',
    // '&:hover': {
    //   transform: 'scale(1.02)',
    //   boxShadow: 10,
    // },
  }}
>
  <CardContent>
    <Typography
      variant="h5"
      gutterBottom
      align="center"
      sx={{
        fontWeight: 'bold',
        color: 'primary.main',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
      }}
    >
      Payments
    </Typography>

    {/* Pie Chart */}
<Box mt={4} height={300}>
  {pieData.every((entry) => entry.value === 0) ? (
    // If all values are 0
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      <Typography variant="h6" color="textSecondary">
        No Data Available
      </Typography>
    </Box>
  ) : (
    // If at least one value > 0
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={pieData}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={80}
          paddingAngle={5}
          dataKey="value"
          label={({ percent }) =>
            `${(percent * 100).toFixed(0)}%`
          }
        >
          {pieData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip />
        <Legend verticalAlign="bottom" height={36} />
      </PieChart>
    </ResponsiveContainer>
  )}
</Box>


  </CardContent>
</Card>
  );
 
  const QuotationList = () => {
    return (
      <Card
        sx={{
          height: '90%',
          marginTop:'20px',
          boxShadow: 4,
          borderRadius: '16px',
          backgroundColor: '#f7fafc',
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: 4,
          },
        }}
      >
          <CardContent>{/* Wrap with LocalizationProvider */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: '10px',
            }}
          >
          {/* Typography in the center */}
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{
                          color: '#333',
                          fontWeight: 'bold',
                          fontSize: '16px',  // Decreased font size
                          textTransform: 'uppercase',
                          margin: '0 auto', // Centers the text in the row
                          paddingBottom: '5px',  // Adjust height by reducing padding
                        }}
                      >
                        Sold Items List
                      </Typography>
                     
                    <FormControl fullWidth variant="outlined" style={{ width: '120px', height: '35px' }}>
                      <InputLabel style={{ fontSize: '12px' }}>Date Range</InputLabel>
                      <Select value={selectedValue} onChange={handleDateRangeChange} label="Date Range" style={{ fontSize: '12px', height: '30px' }}>
                        <MenuItem value="today">Today</MenuItem>
                        <MenuItem value="yesterday">Yesterday</MenuItem>
                        <MenuItem value="lastWeek">Last Week</MenuItem>
                        <MenuItem value="currentMonth">Current Month</MenuItem>
                        <MenuItem value="lastSixMonths">Last 6 Months</MenuItem>
                        <MenuItem value="currentAcademicYear">Academic Year</MenuItem>
                      </Select>
                    </FormControl>

        </div>
    <GlobalStyles
            styles={{
              '.custom-sidebar-scrollbar': {
                scrollbarWidth: 'thin', // For Firefox
                scrollbarColor: 'grey #e0e0e0',
              },
              '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                width: '6px', // For WebKit-based browsers
              },
              '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                background: '#f1f1f1', // Track color
              },
              '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                backgroundColor: 'grey', // Thumb color
                borderRadius: '10px',
              },
              '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555',
              },
            }}
          />
         
        <TableContainer component={Paper}  style={{ maxHeight: '385px', overflowY: 'auto' }} className="custom-sidebar-scrollbar" >
          <Table  stickyHeader>
            <TableHead>
              <TableRow>
                {["S.No","Bill No", "Date","Items","Total Bill Amount"].map((header) => (
                  <TableCell key={header}
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                  >{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody >
            {itemsloading ? (
                <TableRow>
                  {/* <TableCell colSpan={6} style={{ textAlign: "center", padding: "20px",fontSize:'15px' }}>
                    Loading Data...
                  </TableCell> */}
                  <TableCell colSpan={6} style={{ textAlign: "center", padding: "20px" }}>
                                                                                                <Box display="flex" flexDirection="column" alignItems="center">
                                                                                                  <CircularProgress />
                                                                                                  <Typography variant="body2" sx={{ mt: 1 }}>
                                                                                                    Loading Data...
                                                                                                  </Typography>
                                                                                                </Box>
                                                                                              </TableCell>
                </TableRow>
              ) : savedItems.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} style={{ textAlign: "center", padding: "20px" }}>
                    No data available
                  </TableCell>
                </TableRow>
              ) : (
                savedItems.map((row, index) => (
                <TableRow key={index}
                style={{
                  backgroundColor: "white",
                  transition: "background-color 0.3s",
                  height: "40px", // Reduced row height
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "white"; // Default color
                }}
                >
                  <TableCell  sx={{textAlign: "center",borderRight: "1px solid #ddd",padding: "2px"}}>{index + 1}</TableCell>
                  <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd",padding: "2px"}}>{row.billNo}</TableCell>
                  <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd",padding: "2px"}}>{row.date}</TableCell>
                  <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd",padding: "2px",width:"250px"}}>{row.items.join(", ")}</TableCell>
                  {/* <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd",padding: "2px"}}>{row.qty}</TableCell> */}
                  <TableCell sx={{textAlign: "center",borderRight: "1px solid #ddd",padding: "2px"}}>₹{row.billAmount}</TableCell>
                 
                </TableRow>
              ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination component="div" count={filteredQuotations.length} page={page} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage} /> */}
    <ToastContainer />
      </CardContent>
      </Card>
    );
  };



  //Notice Board API
    const fetchNotices = async () => {
      setLoadingNotices(true); // Start loading
      try {
        const response = await fetch(`${baseUrl}/api/noticeBoard/getAll/${oId}/${pId}`); // Replace with your API URL
        const data = await response.json();
        // ✅ Sort notices by purposeDate (future dates first)
        data.sort((a, b) => new Date(b.purposeDate) - new Date(a.purposeDate));
  
        setNotices(data); // Assuming the response is an array
      } catch (error) {
        console.error("Error fetching notices:", error);
      }finally {
        setLoadingNotices(false); // Stop loading
      }
  
    };
  useEffect(() => {
    fetchNotices();
  }, []);

   // Filter notices based on search query
 const filteredNotices = notices.filter((notice) => {
  return (
    notice.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
    notice.purposeDate.toLowerCase().includes(searchQuery.toLowerCase())
    
  );
});




useEffect(() => {
  const fetchExpensesBarGraphData = async () => {

     // Check if UserId is available, if not, return early
    const UserId = userId || selectedUsers;
    if (!UserId) return; // ✅ Don't call API if there's no UserId

    try {
      // const UserId = userId || selectedUsers;
      const response = await fetch(`${baseUrl}/api/principal/last-three-months-expenses/${UserId}/${oId}?selectedMonth=${selectedMonth}`);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      const months = getLastThreeMonths(selectedMonth);
      const formattedData = months
      .filter(month => data[month] !== undefined)
      .map((month, index) => ({
        name: month,
        value: data[month],
        color: index === 0 ? "#8884d8" : index === 1 ? "#82ca9d" : "#ff7300",
      }));
      setExpenseData(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  fetchExpensesBarGraphData();
}, [userId, selectedUsers,selectedMonth]);

const handleMonthChange = (event) => {
  setSelectedMonth(event.target.value);
};
 

 

  return (
    <Box p={3} mt={5} sx={{ backgroundColor: '#f0f4f7' }}>
  {view === 'dashboard' ? (
    <Grid container spacing={1}>

      {/* Sales */}
      <Grid item xs={12} sm={4}>
        <Paper
          style={{
            ...cardStyle,
            borderBottom: `4px solid #007bff`,
            minHeight: "50px",
            height: "100%",
            cursor: "pointer",
          }}
          // onClick={() => navigate("/SoldItems")}
          onClick={() => navigate(`/SoldItems?dateRange=${selectedValue}`)}
        >
          <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%", padding: "8px" }}>
            <Grid item>
              <Grid container alignItems="center">
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "#cce5ff",  // Light Blue
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <InsertChartIcon style={{ fontSize: "18px", color: "#007bff" }} /> {/* Blue */}
                </div>
                <Typography variant="h6" style={{ marginLeft: "8px", fontWeight: "bold" }}>
                  SALES
                </Typography>
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="h5" style={{ color: "#007bff", fontWeight: "bold" }}>
                ₹{itemAmounts || 0}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      {/* Purchase */}
      <Grid item xs={12} sm={4}>
        <Paper
          style={{
            ...cardStyle,
            borderBottom: `4px solid #28a745`,
            minHeight: "50px",
            height: "100%",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/PurchaseInvoiceList?dateRange=${selectedValue}`)}
        >
          <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%", padding: "8px" }}>
            <Grid item>
              <Grid container alignItems="center">
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "#d4edda", // Light Green
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LoyaltyRoundedIcon style={{ fontSize: "18px", color: "#28a745" }} /> {/* Green */}
                </div>
                <Typography variant="h6" style={{ marginLeft: "8px", fontWeight: "bold" }}>
                  PURCHASE
                </Typography>
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="h5" style={{ color: "#28a745", fontWeight: "bold" }}>
                ₹{totalPurchaseAmount || 0}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      {/* Expenses */}
      <Grid item xs={12} sm={4}>
        <Paper
          style={{
            ...cardStyle,
            borderBottom: `4px solid #dc3545`,
            minHeight: "50px",
            height: "100%",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/Store_Expenses?dateRange=${selectedValue}`)}

        >
          <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%", padding: "8px" }}>
            <Grid item>
              <Grid container alignItems="center">
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "#f8d7da", // Light Red
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <RequestQuoteIcon style={{ fontSize: "18px", color: "#dc3545" }} /> {/* Red */}
                </div>
                <Typography variant="h6" style={{ marginLeft: "8px", fontWeight: "bold" }}>
                  EXPENSES
                </Typography>
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="h5" style={{ color: "#dc3545", fontWeight: "bold" }}>
                ₹{totalExpensesAmount  || 0}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

        <Grid item xs={12} sm={isExpanded ? 6 : 8}>
          <QuotationList />
        </Grid>
        <Grid item xs={12} sm={isExpanded ? 6 : 4}>
          <Payments />
        </Grid>

        {/* New Section: Notice Board + Expense Chart */}
        <Grid item xs={12}>
          <div style={{ display: "flex", marginTop: "-10px", paddingTop: "1px", justifyContent: "space-between", height: "400px" }}>
            
                              {/* Notice Board */}
                              <Paper
                                style={{
                                  flex: 2,
                                  padding: "5px",
                                  backgroundColor: "#FFFFFF",
                                  borderRadius: "8px",
                                  marginRight: "5px",
                                  height: "100%",
                                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                }}
                              >
                                <div
                                  style={{
                                    flex: 2,
                                    marginLeft: "0px",
                                    paddingLeft: "10px",
                                    paddingRight: "10px",
                                    overflow: "auto",
                                    height: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      position: "sticky",
                                      top: "0",
                                      backgroundColor: "#FFFFFF",
                                      zIndex: 1,
                                    }}
                                  >
                                    <Typography
                                      variant="h5"
                                      style={{
                                        fontWeight: "bold",
                                        paddingLeft: "5px",
                                        marginTop: "5px",
                                        color: "#333",
                                      }}
                                    >
                                      Notice Board
                                    </Typography>
                                  </div>
                                  <GlobalStyles
                                    styles={{
                                      '.custom-sidebar-scrollbar': {
                                        scrollbarWidth: 'thin',
                                        scrollbarColor: 'grey #e0e0e0',
                                      },
                                      '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                                        width: '6px',
                                      },
                                      '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                      },
                                      '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                                        backgroundColor: 'grey',
                                        borderRadius: '10px',
                                      },
                                      '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                                        backgroundColor: '#555',
                                      },
                                    }}
                                  />
                                  <div className="notice-container custom-sidebar-scrollbar" style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                                    {loadingNotices ? (
                                      <Box display="flex" flexDirection="column" alignItems="center" width="100%" sx={{ mt: 2 }}>
                                        <CircularProgress />
                                        <Typography variant="body2" sx={{ mt: 1 }}>
                                          Loading Notices...
                                        </Typography>
                                      </Box>
                                    ) : filteredNotices.length === 0 ? (
                                      <Typography
                                        variant="h6"
                                        sx={{
                                          textAlign: "center",
                                          color: "#666",
                                          width: "100%",
                                          padding: "20px",
                                          fontStyle: "italic",
                                        }}
                                      >
                                        No notices available.
                                      </Typography>
                                    ) : (
                                      filteredNotices.map((notice, index) => (
                                        <Box
                                          key={index}
                                          sx={{
                                            padding: "15px",
                                            borderRadius: "10px",
                                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                                            backgroundColor: "#D1E9F6",
                                            position: "relative",
                                            overflow: "hidden",
                                            marginBottom: "10px",
                                          }}
                                        >
                                          {new Date() - new Date(notice.purposeDate) < 24 * 60 * 60 * 1000 && (
                                            <Box
                                              sx={{
                                                position: "absolute",
                                                top: "0",
                                                right: "0",
                                                backgroundColor: "blue",
                                                color: "#fff",
                                                fontWeight: "bold",
                                                fontSize: "0.75rem",
                                                padding: "6px 12px",
                                                textTransform: "uppercase",
                                                borderTopRightRadius: "8px",
                                                borderBottomLeftRadius: "8px",
                                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                              }}
                                            >
                                              New!
                                            </Box>
                                          )}
            
                                          <Box
                                            sx={{
                                              backgroundColor: "#4CAF50",
                                              color: "white",
                                              width:"110px",
                                              padding: "5px 10px",
                                              borderRadius: "5px",
                                              fontWeight: "bold",
                                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                              "&:hover": {
                                                transform: "scale(1.05)",
                                              },
                                            }}
                                          >
                                            {notice.purposeDate}
                                          </Box>
            
                                          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333", marginTop: "10px" }}>
                                            {notice.title}
                                          </Typography>
                                          <Typography variant="body2" sx={{ marginTop: "5px", color: "#333", fontWeight: "bold" }}>
                                            {notice.description}
                                          </Typography>
                                          <Typography variant="body2" sx={{ marginTop: "5px", fontStyle: "italic", color: "#444" }}>
                                            Sent By: {notice.nameOfCreatedByNotice}, Time: {notice.time}
                                          </Typography>
                                        </Box>
                                      ))
                                    )}
                                  </div>
                                </div>
                              </Paper>

                                {/* Expenses Bar Chart */}
                              <div style={{ position: "relative", width: "40%" }}>
                                <TableContainer
                                        style={{ backgroundColor: "#FFFFFF", borderRadius: "8px", paddingTop: "20px",height: "100%", }}
                                      >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "0 0 10px 10px",
                                        
                                      }}
                                    >
                                      <Typography variant="h5" style={{ fontWeight: "bold", color: "#333" }}>
                                        Expenses
                                      </Typography>
                                
                                      <div style={{ display: "flex", gap: "10px" }}>
                                        {/* {isPrincipal && (
                                          <FormControl fullWidth style={{ width: "150px" }} size="small">
                                            <InputLabel>Select Admin</InputLabel>
                                            <Select
                                              value={selectedUsers}
                                              onChange={(e) => setSelectedUsers(e.target.value)}
                                              label="Select Admin"
                                            >
                                              {users.map((user) => (
                                                <MenuItem key={user.userId} value={user.userId}>
                                                  {user.userId}-{user.firstName} {user.lastName}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                          </FormControl>
                                        )} */}
                                        <FormControl style={{ width: "120px", paddingRight: "10px" }}>
                                          <InputLabel id="expense-month-select-label" style={{ fontSize: "12px" }}>
                                            Select Month
                                          </InputLabel>
                                          <Select
                                            labelId="expense-month-select-label"
                                            value={selectedMonth}
                                            onChange={handleMonthChange}
                                            style={{ height: "35px", fontSize: "12px" }}
                                            label="Select Month"
                                          >
                                            {months.map((month, index) => (
                                              <MenuItem key={index} value={month}>
                                                {month}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </div>
                                
                                    <Table>
                                      <TableBody>
                                        <TableRow>
                                          <TableCell style={{ padding: 0, height: "100%", textAlign: "center", borderBottom: "none" }}>
                                            {expenseData.length > 0 ? (
                                              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <BarChart width={280} height={300} data={expenseData}>
                                                  <XAxis dataKey="name" interval={0}/>
                                                  <YAxis />
                                                  <Tooltip />
                                                  <Bar dataKey="value">
                                                    {expenseData.map((entry, index) => (
                                                      <Cell key={index} fill={entry.color} />
                                                    ))}
                                                  </Bar>
                                                </BarChart>
                                                <div
                                                  style={{
                                                    paddingLeft: "20px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  {expenseData.map((entry, index) => (
                                                    <div
                                                      key={index}
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        marginBottom: "8px",
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          width: "10px",
                                                          height: "10px",
                                                          backgroundColor: entry.color,
                                                          marginRight: "5px",
                                                        }}
                                                      ></div>
                                                      <Typography
                                                        variant="body2"
                                                        style={{
                                                          color: "#333",
                                                          fontWeight: "bold",
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        {entry.name}
                                                      </Typography>
                                                    </div>
                                                  ))}
                                                </div>
                                              </div>
                                            ) : (
                                              <Typography variant="body2" style={{ color: "#999", fontSize: "14px" }}>
                                                No expense data available
                                              </Typography>
                                            )}
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                </TableContainer>
                              </div>
          </div>
        </Grid>

      </Grid>
    ) : view === 'quotations' ? (
      <QuotationList />
    ) : null}
  </Box>

    );
  };

export default StoreDashboard;